import { render, staticRenderFns } from "./echartGetDish.vue?vue&type=template&id=6610d4d7&scoped=true&"
import script from "./echartGetDish.vue?vue&type=script&lang=js&"
export * from "./echartGetDish.vue?vue&type=script&lang=js&"
import style0 from "./echartGetDish.vue?vue&type=style&index=0&id=6610d4d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610d4d7",
  null
  
)

export default component.exports